import { forwardRef } from 'react';
import type { JSX } from 'react';

import { cn } from '@/utils/cn';

type Props = {
  className?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Input = forwardRef<HTMLInputElement, Props>(
  ({ className = '', onChange, onBlur, ...rest }, ref): JSX.Element => {
    return (
      <input
        className={cn(
          'block w-full rounded-md border-0 bg-white px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-amber-800 focus:ring-inset sm:text-sm sm:leading-6',
          className,
        )}
        onChange={onChange}
        onBlur={onBlur}
        {...rest}
        ref={ref}
      />
    );
  },
);

Input.displayName = 'Input';

export default Input;
